import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const getEstimate = {
    namespaced: true,
    state: {
        estimationsData: [],
        dataGetEstimationsFetching: false,
    },
    mutations: {
        GET_ESTIMATE_SUCCESS(state, response) {
            state.estimationsData = response.data;
            eventBus.$emit("getEstimateSuccess", response["data"]);
            state.dataGetEstimationsFetching = false;
        },
        GET_ESTIMATE_FAILURE(state, error) {
            console.log(error);
            state.dataGetEstimationsFetching = false;
            eventBus.$emit("getEstimateFailure");
        }
    },
    actions: {
        getEstimate: function({ dispatch, state }, data) {
            let payload = { creds: {} }
            if(data.id === null) {
                let url = new URL(window.location.href);
                payload.creds.projectId = url.searchParams.get("id");
            } else {
                payload.creds.projectId = data.id;
            }
            if (data.toCreate) {
                payload.creds.toCreate = data.toCreate;
            } 
            state.dataGetEstimationsFetching = true;
            let urlParams = data.measurementId === undefined ? payload.creds.projectId : payload.creds.projectId + '/' + data.measurementId
            let promise = sendRequest("get", config.baseURLApi + "/estimates-project/" + urlParams, {}, {}, true, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successGetEstimate", result[1]);
                } else {
                    dispatch("failureGetEstimate", result[1]);
                }
            })
        },
        successGetEstimate: function({ commit }, response) {
            commit("GET_ESTIMATE_SUCCESS", response);
        },
        failureGetEstimate: function({ commit }, error) {
            commit("GET_ESTIMATE_FAILURE", error);
        }
    }
}

export default getEstimate;